import type { CloudpackConfig, PackageDefinitionsCache } from '@ms-cloudpack/common-types';
import { PackageDefinitions } from '@ms-cloudpack/package-utilities';
import { createPackageSettingsTransform } from './createPackageSettingsTransform.js';
import { createBuiltInSettingsTransform } from '../builtInSettings/createBuiltInSettingsTransform.js';

/**
 * Given a Cloudpack config, create a package definitions cache with transforms resulting from settings defined
 * within the config.
 */
export function createPackageDefinitions(params: { config: CloudpackConfig }): PackageDefinitionsCache {
  const { config } = params;
  const packages = new PackageDefinitions({ config });

  packages.registerTransform(() => createBuiltInSettingsTransform());
  packages.registerTransform((newConfig) => (newConfig ? createPackageSettingsTransform(newConfig) : () => undefined));

  return packages;
}
